export default "__VITE_ASSET__bc6$dJmr__"